import React from "react";
import './loader.css'

export const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};